export const getCategoryIconColor = (category: string) => {
  if (!category) {
    return null;
  }

  const colorMap: Record<string, string> = {
    red: '#ed205b',
    orange: '#ee8517',
    yellow: '#efbc20',
    green: '#59c936',
    blue: '#1b9fe6',
    violet: '#bc68d0',
    brown: '#927551',
    darkblue: '#01307c',
    darkred: '#871c09',
    darkgreen: '#17660b',
    purple: '#5a2d87',
    watergreen: '#33e8c0',
  };

  return colorMap[category] ?? null;
};
